module.exports = __webpack_public_path__ + "static/media/demo-8.3fa77a1a.jpg";